// @flow

import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import type { Theme } from '../../../types';
import { dateFormatter, dateParser, removeHTMLTags } from '../../../helpers';
import { type ACFImage } from '../../../types/acf';

type Props = {
  highlight: boolean,
  image: ?ACFImage,
  date: string,
  title: string,
  intro: string,
  link: string,
  readMoreLabel: string,
};

type StyledProps = {
  image?: string;
  highlight: boolean,
};

const Date = styled<any, Theme>('div')`
  color: ${props => props.theme.news.dateColor};
  margin: 1rem 0 0.75rem 0;
`;

const Intro = styled<any, Theme>('p')`
  line-height: 1.75rem;
  margin: 0.5rem 0;
`;

const Title = styled<any, Theme>('h2')`
  color: ${props => props.theme.news.titleColor};
`;

const StyledLink = styled<typeof Link, Theme>(Link)`
  text-decoration: none;
  color:  ${props => props.theme.news.linkColor};
  &:hover {
    color:  ${props => props.theme.news.linkHoverColor};
    text-decoration: underline;
  }
  &::after {
    content: ' ›';
  }
`;

const Clickable = styled<typeof Link, Theme>(Link)`
  text-decoration: none;
`;

const Container = styled<any, Theme>('article')`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${props => props.theme.divider.color};
  padding: 2rem 0 2rem 0;
  align-self: stretch;
  height: 100%;
  box-sizing: border-box;
`;

const NewsImage = styled<any, Theme, StyledProps>('div')`
  height: ${props => (props.highlight ? '18rem' : '8.5rem')};
  background: url(${props => props.image && props.image});
  background-position: center;
  background-size: cover;
  flex-shrink: 0;
`;

const NewsPreview = ({
  highlight,
  image,
  date,
  title,
  intro,
  link,
  readMoreLabel,
}: Props) => (
  <Container>
    <Clickable to={link}>
      { image ? <NewsImage highlight={highlight} image={image.sizes.medium_large} /> : null}
    </Clickable>
    <Date>{dateFormatter(dateParser(date))}</Date>
    <Clickable to={link}>
      <Title>{title}</Title>
    </Clickable>
    <Intro>{removeHTMLTags(intro)}</Intro>
    <StyledLink to={link}>
      {readMoreLabel}
    </StyledLink>
  </Container>
);

export default NewsPreview;
